<template>
  <v-card class="mx-auto" max-width="400">
    <v-toolbar v-if="title" flat dense>
      <v-toolbar-title>
        <span class="subheading">{{ title }}</span>
      </v-toolbar-title>
      <v-btn icon>
        <v-icon>mdi-thermometer</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="8">
          <span
            :key="'a_' + temperatureReading"
            :class="[
              $vuetify.breakpoint.mdAndUp?'display-3':'display-1',
              'font-weight-light',
              color ? color + '--text' : ''
            ]"
          >{{ temperatureReading }}</span>
          <span class="subheading font-weight-light mr-1">°C</span>
        </v-col>
        <v-col v-if="subTitle">
          <div class="subheading font-weight-light mr-1">{{subTitle}}</div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    temperatureValue: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default: "Temperatura"
    },
    subTitle: {
      type: String,
      default: ""
    }
  },
  data: () => ({}),
  computed: {
    temperature() {
      return this.temperatureValue;
    },
    color() {
      if (this.temperature < 360) return "indigo";
      if (this.temperature < 365) return "green";
      if (this.temperature < 375) return "amber";
      if (this.temperature < 380) return "orange";
      return "red";
    },
    // parseFloat(parseFloat(37.512).toPrecision(3)).toLocaleString("it-IT")
    temperatureReading() {
      return this.temperature > 100
        ? (this.temperature * 0.1).toLocaleString("it-IT")
        : " ";
    }
  }
};
</script>
